/**
 * Anchor names for the host walkthrough. Pages render them as `data-tour`
 * attributes; the tour looks them up by selector. Keeping the names here means
 * a rename touches one file plus the JSX that renders it.
 */
export const TOUR = {
  navTabs: 'nav-tabs',
  guideButton: 'guide-button',

  activitiesTabs: 'activities-tabs',
  activitiesTabDraft: 'activities-tab-draft',
  activitiesTabActive: 'activities-tab-active',
  activitiesTabPast: 'activities-tab-past',
  activitiesCreate: 'activities-create',
  activityCard: 'activity-card',
  activityCardSessions: 'activity-card-sessions',
  activityCardActions: 'activity-card-actions',

  afTitle: 'af-title',
  afDescription: 'af-description',
  afCategory: 'af-category',
  afChildPrice: 'af-child-price',
  afAdultPrice: 'af-adult-price',
  afType: 'af-type',
  afCapacity: 'af-capacity',
  afAge: 'af-age',
  afRegions: 'af-regions',
  afLocation: 'af-location',
  afMedia: 'af-media',
  afDeadline: 'af-deadline',
  afAddSession: 'af-add-session',
  afSessionItem: 'af-session-item',
  afSessionRepeat: 'af-session-repeat',
  afSubmit: 'af-submit',

  coursesTabs: 'courses-tabs',
  coursesCreate: 'courses-create',
  courseCard: 'course-card',
  ceTitle: 'ce-title',
  cePrice: 'ce-price',
  ceAge: 'ce-age',
  ceImages: 'ce-images',
  ceSave: 'ce-save',
  ceLessons: 'ce-lessons',
  ceLessonStatus: 'ce-lesson-status',
  cePreview: 'ce-preview',

  passesTabs: 'passes-tabs',
  passesTabPending: 'passes-tab-pending',
  passesTabActive: 'passes-tab-active',
  passesCreate: 'passes-create',
  passCard: 'pass-card',
  passCardActions: 'pass-card-actions',
  pfActivity: 'pf-activity',
  pfBasic: 'pf-basic',
  pfPrice: 'pf-price',
  pfTotalSessions: 'pf-total-sessions',
  pfMaxSales: 'pf-max-sales',
  pfExpires: 'pf-expires',
  pfSessions: 'pf-sessions',
  pfSubmit: 'pf-submit',

  bookingsTabs: 'bookings-tabs',
  bookingsExport: 'bookings-export',
  bookingsTable: 'bookings-table',
  bookingsColConsent: 'bookings-col-consent',
  bookingsRowActions: 'bookings-row-actions',
  bxDataset: 'bx-dataset',
  bxFilters: 'bx-filters',

  emailFilter: 'email-filter',
  emailBulk: 'email-bulk',
  emailSessionCard: 'email-session-card',
  emailDetailLink: 'email-detail-link',
  emailDetailCol: 'email-detail-col',
  emailDetailActions: 'email-detail-actions',
  emailReminderCol: 'email-reminder-col',
} as const;

export type TourTarget = (typeof TOUR)[keyof typeof TOUR];

/** Spread onto a JSX element: `<div {...tourAttr(TOUR.afTitle)}>`. */
export function tourAttr(target: TourTarget): { 'data-tour': TourTarget } {
  return { 'data-tour': target };
}

export function tourSelector(target: string): string {
  return `[data-tour="${target}"]`;
}
